import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { courseStudentLevel, signPage, updataCourse, coursePage, subjectPage, packetPage, 
customerPage, studentPage, businessPage, orderPage, employeePage, teacherPage, campusPage, 
courseTypePage, courseLevelPage, courseMaterialPage, essentialPage, difficultyPage, instrumentPage, 
studentLevelPage, customerSourcePage, teacherLevelPage, bannerPage, articlePage, agreementPage, 
aboutPage, options, deleteItem, addItem, addItemOrder, addItemCustomer, editItem, editItemEnabled, 
editItemConnect, studentDetail, instrumentUse, getSchoolCampus, studentUpdate, getInstrumentType, 
studentRemark, studentCourse, getMaterial, baseCourse, getCourseSignList, getOrder, getBusiness, 
getBusinessDetails, getPacket, saleGoodsList, getPacketData, getOrderDetail, modifyOrderDetail, 
getEssentialList, getSubject, customeInfo, deleteStudentValue, getAllTheme, addAllTheme, upleveldate, 
studentLocked, employeeDetail, essentialList, getAllTeacher, alertEssential, newEssential, auditionCourseSign, 
readAgreement, logsList, modifyLogs, deleteStudentRemark, editStudentRemark, getCustomerPhoneInfo, exportCourse, 
getOptionId, selectHistory, urlTypePage, feedbackStatus, updateSortColor, setHistory, customerDetail, pageLogs, 
customerMap, getEssentialMaterial, upPicture, goodsSalePage, goodsUsePage, goodsPage, courseSignLoges, 
getPerformance, putFeedback, addGoods, getGoods, editGoods, updateGoodsStatus, updateGoodsInfo, getGoodsDetails, 
messageTemplate, getMessageTask, messageTaskPost, messageTaskPut, getMessageTaskDetails, deleteMessageTask, 
getRecordList, putRecordList, cluePage, getGoodsBand, eduClueStatus, messageNoticeEnable, messageEnable, 
eduupdateSubjectSort, eduupdateEssentialSort, getPacketBaseCourse, getBaseCourseAll, PacketBaseCourse, 
updatePacketBaseCourse, deletePacketBaseCourse, getBaseCourseByCourseID, getCourseByID, reserveCourseSign,
PacketBaseCourseTrue, addPacketBaseCourse, updatePacketBaseCourseSort, baseCourseDetail, packetList,
courseRecordList } from '@/api/course'
import store from '@/store'

@Module({ dynamic: true, store, name: 'course' })
class Course extends VuexModule {
  @Action({ rawError: true })
  public async courseStudentLevel({ org_id }) {
    return await courseStudentLevel(org_id)
  }
  @Action({ rawError: true })
  public async signPage({ org_id }) {
    return await signPage(org_id)
  }
  @Action({ rawError: true })
  public async updataCourse({ data, upId }) {
    return await updataCourse(data, upId)
  }
  @Action({ rawError: true })
  public async exportCourse({ data, upId, t }) {
    return await exportCourse(data, upId, t)
  }
  @Action({ rawError: true })
  public async coursePage({ org_id }) {
    return await coursePage(org_id)
  }
  @Action({ rawError: true })
  public async subjectPage({ org_id }) {
    return await subjectPage(org_id)
  }
  @Action({ rawError: true })
  public async packetPage({ org_id }) {
    return await packetPage(org_id)
  }
  @Action({ rawError: true })
  public async customerPage({ org_id }) {
    return await customerPage(org_id)
  }
  @Action({ rawError: true })
  public async studentPage({ org_id }) {
    return await studentPage(org_id)
  }
  @Action({ rawError: true })
  public async businessPage({ org_id }) {
    return await businessPage(org_id)
  }
  @Action({ rawError: true })
  public async orderPage({ org_id }) {
    return await orderPage(org_id)
  }
  @Action({ rawError: true })
  public async employeePage({ org_id }) {
    return await employeePage(org_id)
  }
  @Action({ rawError: true })
  public async teacherPage({ org_id }) {
    return await teacherPage(org_id)
  }
  @Action({ rawError: true })
  public async campusPage({ org_id }) {
    return await campusPage(org_id)
  }
  @Action({ rawError: true })
  public async courseTypePage({ org_id }) {
    return await courseTypePage(org_id)
  }
  @Action({ rawError: true })
  public async courseLevelPage({ org_id }) {
    return await courseLevelPage(org_id)
  }
  @Action({ rawError: true })
  public async baseCourseDetail({ base_course_id }) {
    return await baseCourseDetail(base_course_id)
  }
  @Action({ rawError: true })
  public async courseMaterialPage({ org_id }) {
    return await courseMaterialPage(org_id)
  }
  @Action({ rawError: true })
  public async essentialPage({ org_id }) {
    return await essentialPage(org_id)
  }
  @Action({ rawError: true })
  public async difficultyPage({ org_id }) {
    return await difficultyPage(org_id)
  }
  @Action({ rawError: true })
  public async instrumentPage({ org_id }) {
    return await instrumentPage(org_id)
  }
  @Action({ rawError: true })
  public async urlTypePage({ url_type, org_id }) {
    return await urlTypePage(url_type, org_id)
  }
  @Action({ rawError: true })
  public async studentLevelPage({ org_id }) {
    return await studentLevelPage(org_id)
  }
  @Action({ rawError: true })
  public async customerSourcePage({ org_id }) {
    return await customerSourcePage(org_id)
  }
  @Action({ rawError: true })
  public async teacherLevelPage({ org_id }) {
    return await teacherLevelPage(org_id)
  }
  @Action({ rawError: true })
  public async bannerPage({ org_id }) {
    return await bannerPage(org_id)
  }
  @Action({ rawError: true })
  public async articlePage({ org_id }) {
    return await articlePage(org_id)
  }
  @Action({ rawError: true })
  public async cluePage({ org_id }) {
    return await cluePage(org_id)
  }
  @Action({ rawError: true })
  public async agreementPage({ org_id }) {
    return await agreementPage(org_id)
  }
  @Action({ rawError: true })
  public async aboutPage({ org_id }) {
    return await aboutPage(org_id)
  }
  @Action({ rawError: true })
  public async goodsSalePage({ org_id }) {
    return await goodsSalePage(org_id)
  }
  @Action({ rawError: true })
  public async goodsUsePage({ org_id }) {
    return await goodsUsePage(org_id)
  }
  @Action({ rawError: true })
  public async goodsPage({ org_id }) {
    return await goodsPage(org_id)
  }
  @Action({ rawError: true })
  public async options({ optionId, org_id }) {
    return await options(optionId, org_id)
  }
  @Action({ rawError: true })
  public async deleteItem({ data, optionId }) {
    return await deleteItem(data, optionId)
  }
  @Action({ rawError: true })
  public async addItem({ data, optionId }) {
    return await addItem(data, optionId)
  }
  @Action({ rawError: true })
  public async addItemOrder({ data }) {
    return await addItemOrder(data)
  }
  @Action({ rawError: true })
  public async addItemCustomer({ data }) {
    return await addItemCustomer(data)
  }
  @Action({ rawError: true })
  public async editItem({ data, optionId }) {
    return await editItem(data, optionId)
  }
  @Action({ rawError: true })
  public async editItemEnabled({ data, optionId }) {
    return await editItemEnabled(data, optionId)
  }
  @Action({ rawError: true })
  public async editItemConnect({ data, optionId }) {
    return await editItemConnect(data, optionId)
  }
  @Action({ rawError: true })
  public async studentDetail({ student_id }) {
    return await studentDetail(student_id)
  }
  @Action({ rawError: true })
  public async instrumentUse({ teacher_employee_id }) {
    return await instrumentUse(teacher_employee_id)
  }
  @Action({ rawError: true })
  public async getSchoolCampus({ types, org_id }) {
    return await getSchoolCampus(types, org_id)
  }
  @Action({ rawError: true })
  public async studentUpdate(data) {
    return await studentUpdate(data)
  }
  @Action({ rawError: true })
  public async getInstrumentType({ org_id }) {
    return await getInstrumentType(org_id)
  }
  @Action({ rawError: true })
  public async studentRemark(data) {
    return await studentRemark(data)
  }
  @Action({ rawError: true })
  public async studentCourse({ course_name, student_id, sign_student_level_id, student_level_id, course_type_id, teacher_id, sign_type, instrument_type_id, campus_id, start_time, end_time, is_formal, ages, page, size, is_distinct_student, packet_id }) {
    return await studentCourse(course_name, student_id, sign_student_level_id, student_level_id, course_type_id, teacher_id, sign_type, instrument_type_id, campus_id, start_time, end_time, is_formal, ages, page, size, is_distinct_student, packet_id)
  }
  @Action({ rawError: true })
  public async auditionCourseSign({ business_id, course_type_id, teacher_id, sign_type, instrument_type_id, campus_id, start_time, end_time, page, size}) {
    return await auditionCourseSign( business_id, course_type_id, teacher_id, sign_type, instrument_type_id, campus_id, start_time, end_time, page, size)
  }
  @Action({ rawError: true })
  public async getMaterial({ org_id, teacherEmployeeId, student_id }) {
    return await getMaterial(org_id, teacherEmployeeId, student_id)
  }
  @Action({ rawError: true })
  public async getEssentialMaterial({ org_id, teacherEmployeeId, student_id, instrument_type_id }) {
    return await getEssentialMaterial(org_id, teacherEmployeeId, student_id, instrument_type_id)
  }
  @Action({ rawError: true })
  public async baseCourse({ org_id, campus_id }) {
    return await baseCourse(org_id, campus_id)
  }
  @Action({ rawError: true })
  public async getCourseSignList({ student_id, course_id ,types, org_id }) {
    return await getCourseSignList(student_id, course_id, types, org_id)
  }
  @Action({ rawError: true })
  public async getOrder({ student_id }) {
    return await getOrder(student_id)
  }
  @Action({ rawError: true })
  public async getBusiness({ business_id, customer_id }) {
    return await getBusiness(business_id, customer_id)
  }
  @Action({ rawError: true })
  public async getBusinessDetails({ business_id, is_show }) {
    return await getBusinessDetails(business_id, is_show)
  }
  @Action({ rawError: true })
  public async getPacket({ packet_id }) {
    return await getPacket(packet_id)
  }
  @Action({ rawError: true })
  public async packetList() {
    return await packetList()
  }
  @Action({ rawError: true })
  public async saleGoodsList({ campus_id }) {
    return await saleGoodsList(campus_id)
  }
  @Action({ rawError: true })
  public async getPacketData({ campus_id }) {
    return await getPacketData(campus_id)
  }
  @Action({ rawError: true })
  public async getOrderDetail({ order_id }) {
    return await getOrderDetail(order_id)
  }
  @Action({ rawError: true })
  public async modifyOrderDetail(data) {
    return await modifyOrderDetail(data)
  }
  @Action({ rawError: true })
  public async getEssentialList({ subject_id }) {
    return await getEssentialList(subject_id)
  }
  @Action({ rawError: true })
  public async getSubject({ packet_id }) {
    return await getSubject(packet_id)
  }
  @Action({ rawError: true })
  public async customeInfo({ customer_id }) {
    return await customeInfo(customer_id)
  }
  @Action({ rawError: true })
  public async deleteStudentValue({ student_id, subject_id }) {
    return await deleteStudentValue(student_id, subject_id)
  }
  @Action({ rawError: true })
  public async getAllTheme({ instrument_type_id }) {
    return await getAllTheme(instrument_type_id)
  }
  @Action({ rawError: true })
  public async addAllTheme(data) {
    return await addAllTheme(data)
  }
  @Action({ rawError: true })
  public async upleveldate(data) {
    return await upleveldate(data)
  }
  @Action({ rawError: true })
  public async studentLocked(data) {
    return await studentLocked(data)
  }
  @Action({ rawError: true })
  public async employeeDetail({ employee_id }) {
    return await employeeDetail(employee_id)
  }
  @Action({ rawError: true })
  public async essentialList(data) {
    return await essentialList(data)
  }
  @Action({ rawError: true })
  public async getAllTeacher({ is_all }) {
    return await getAllTeacher(is_all)
  }
  @Action({ rawError: true })
  public async alertEssential({ level }) {
    return await alertEssential(level)
  }
  @Action({ rawError: true })
  public async newEssential(data) {
    return await newEssential(data)
  }
  @Action({ rawError: true })
  public async readAgreement() {
    return await readAgreement()
  }
  @Action({ rawError: true })
  public async logsList({ employee_id, data_id, table_name, type, start_time, end_time, page, size, data_name, data_content_name }) {
    return await logsList( employee_id, data_id, table_name, type, start_time, end_time, page, size, data_name, data_content_name )
  }
  @Action({ rawError: true })
  public async modifyLogs(data) {
    return await modifyLogs(data)
  }
  @Action({ rawError: true })
  public async deleteStudentRemark({id}) {
    return await deleteStudentRemark(id)
  }
  @Action({ rawError: true })
  public async editStudentRemark(data) {
    return await editStudentRemark(data)
  }
  @Action({ rawError: true })
  public async getCustomerPhoneInfo({ phone }) {
    return await getCustomerPhoneInfo(phone)
  }
  @Action({ rawError: true })
  public async getOptionId() {
    return await getOptionId()
  }
  @Action({ rawError: true })
  public async selectHistory({ page_name }) {
    return await selectHistory(page_name)
  }
  @Action({ rawError: true })
  public async feedbackStatus(data) {
    return await feedbackStatus(data)
  }
  @Action({ rawError: true })
  public async eduClueStatus(data) {
    return await eduClueStatus(data)
  }
  @Action({ rawError: true })
  public async updateSortColor(data) {
    return await updateSortColor(data)
  }
  @Action({ rawError: true })
  public async setHistory( { data, page_key }) {
    return await setHistory(data, page_key)
  }
  @Action({ rawError: true })
  public async customerDetail( { customer_id }) {
    return await customerDetail(customer_id)
  }
  @Action({ rawError: true })
  public async pageLogs( { data_id, page_name }) {
    return await pageLogs(data_id, page_name)
  }
  @Action({ rawError: true })
  public async customerMap() {
    return await customerMap()
  }
  @Action({ rawError: true })
  public async upPicture(data) {
    return await upPicture(data)
  }
  @Action({ rawError: true })
  public async courseSignLoges({student_id, page, size}) {
    return await courseSignLoges(student_id, page, size)
  }
  @Action({ rawError: true })
  public async getPerformance({types, campus, teacher, start_time, end_time}) {
    return await getPerformance(types, campus, teacher, start_time, end_time)
  }
  @Action({ rawError: true })
  public async putFeedback(data) {
    return await putFeedback(data)
  }
  @Action({ rawError: true })
  public async addGoods(data) {
    return await addGoods(data)
  }
  @Action({ rawError: true })
  public async getGoods({id}) {
    return await getGoods(id)
  }
  @Action({ rawError: true })
  public async editGoods(data) {
    return await editGoods(data)
  }
  @Action({ rawError: true })
  public async getGoodsDetails({ id }) {
    return await getGoodsDetails(id)
  }
  @Action({ rawError: true })
  public async updateGoodsStatus(data) {
    return await updateGoodsStatus(data)
  }
  @Action({ rawError: true })
  public async updateGoodsInfo(data) {
    return await updateGoodsInfo(data)
  }
  @Action({ rawError: true })
  public async messageTemplate() {
    return await messageTemplate()
  }
  @Action({ rawError: true })
  public async getMessageTask({ template_id, id, employee_id, name, page, size }) {
    return await getMessageTask(template_id, id, employee_id, name, page, size)
  }
  @Action({ rawError: true })
  public async messageTaskPost(data) {
    return await messageTaskPost(data)
  }
  @Action({ rawError: true })
  public async messageTaskPut(data) {
    return await messageTaskPut(data)
  }
  @Action({ rawError: true })
  public async getMessageTaskDetails({ id }) {
    return await getMessageTaskDetails(id)
  }
  @Action({ rawError: true })
  public async deleteMessageTask({ id }) {
    return await deleteMessageTask(id)
  }
  @Action({ rawError: true })
  public async getRecordList({ template_id, phone, name, page, size }) {
    return await getRecordList(template_id, phone, name, page, size)
  }
  @Action({ rawError: true })
  public async putRecordList(data) {
    return await putRecordList(data)
  }
  @Action({ rawError: true })
  public async messageEnable(data) {
    return await messageEnable(data)
  }
  @Action({ rawError: true })
  public async getGoodsBand() {
    return await getGoodsBand()
  }
  @Action({ rawError: true })
  public async messageNoticeEnable() {
    return await messageNoticeEnable()
  }
  @Action({ rawError: true })
  public async eduupdateEssentialSort(data) {
    return await eduupdateEssentialSort(data)
  }
  @Action({ rawError: true })
  public async eduupdateSubjectSort(data) {
    return await eduupdateSubjectSort(data)
  }
  @Action({ rawError: true })
  public async getPacketBaseCourse({ packet_id }) {
    return await getPacketBaseCourse(packet_id)
  }
  @Action({ rawError: true })
  public async getBaseCourseAll() {
    return await getBaseCourseAll()
  }
  @Action({ rawError: true })
  public async PacketBaseCourse(data) {
    return await PacketBaseCourse(data)
  }
  @Action({ rawError: true })
  public async updatePacketBaseCourse(data) {
    return await updatePacketBaseCourse(data)
  }
  @Action({ rawError: true })
  public async deletePacketBaseCourse(data) {
    return await deletePacketBaseCourse(data)
  }
  @Action({ rawError: true })
  public async updatePacketBaseCourseSort(data) {
    return await updatePacketBaseCourseSort(data)
  }
  @Action({ rawError: true })
  public async getBaseCourseByCourseID({course_id}) {
    return await getBaseCourseByCourseID(course_id)
  }
  @Action({ rawError: true })
  public async getCourseByID({course_id}) {
    return await getCourseByID(course_id)
  }
  @Action({ rawError: true })
  public async reserveCourseSign(data) {
    return await reserveCourseSign(data)
  }
  @Action({ rawError: true })
  public async PacketBaseCourseTrue({packet_id, base_course_id}) {
    return await PacketBaseCourseTrue(packet_id, base_course_id)
  }
  @Action({ rawError: true })
  public async addPacketBaseCourse({ packet_id }) {
    return await addPacketBaseCourse(packet_id)
  }
  @Action({ rawError: true })
  public async courseRecordList({ course_id }) {
    return await courseRecordList(course_id)
  }
}

export const CourseModule = getModule(Course)
